import { capitalize } from 'lodash';

import { updateMultipleNotifications } from 'api/Notifications';

import { formatDate } from 'lib/helpers/utility';

import { showAlert } from 'components/shared/Alert/Alert';

import Actions from '../components/Actions';
import Type from '../components/Type';

export const notificationIconType = (type) => {
  switch (type) {
    case 'treatment_plan':
      return 'pentool-mono';
    case 'clinical_note':
      return 'note-mono';
    case 'e_fax':
      return 'import-1-mono';
    case 'e_fax_signature':
      return 'pentool-mono';
    case 'task':
      return 'task-mono';
    default:
      return 'bell-mono';
  }
};

export const defaultColumns = (timezone) => [
  {
    field: 'type',
    headerName: 'Type',
    cellClass: 'no-border',
    cellRenderer: Type,
    maxWidth: 200,
    minWidth: 100,
    resizable: false,
    headerCheckboxSelection: true,
    checkboxSelection: (params) => !params.node.group
  },
  {
    field: 'title',
    headerName: 'Title',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? capitalize(value) : '-'),
    flex: 1
  },
  {
    field: 'content',
    headerName: 'Content',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? value : '-'),
    flex: 2
  },
  {
    field: 'is_read',
    headerName: 'Status',
    cellClass: 'no-border',
    cellRenderer: ({ value }) => (value ? 'Read' : 'Unread'),
    flex: 1
  },
  {
    field: 'created_at',
    headerName: 'Created at',
    cellClass: 'no-border',
    valueFormatter: ({ value }) => (value ? formatDate(value, timezone) : '-'),
    flex: 1
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellClass: 'no-border',
    cellRenderer: Actions,
    maxWidth: 88,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

export const DEFAULT_FILTERS = {
  created_at: {
    type: 'date-range',
    title: 'Created At',
    icon: 'calendar-mono'
  },
  title: {
    title: 'Notification Title',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'editor-text-mono'
  },
  type: {
    title: 'Notification Type',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'list-unordered-mono'
  }
};

export const updateMultiple = async ({
  notifications,
  data,
  setSelectedRows,
  navigate,
  queryClient
}) => {
  const params = { notifications, ...data };

  await updateMultipleNotifications(navigate, params);
  queryClient.invalidateQueries(['unreadNotificationsCount']);
  queryClient.invalidateQueries(['notifications']);
  setSelectedRows([]);
  showAlert({ title: `Successfully updated  notifications` });
};
